import * as types from 'modules/tireScan/actionTypes';
import type { FetchTireScansSuccessAction, TireScan } from 'modules/tireScan/types';
import { indexByProp } from 'utils/global';
import { uniq } from 'utils/ObjectUtils';
import { createReducer } from 'utils/ReduxUtils';

export type TireScansDataReducer = {
  entities: Record<string, TireScan>;
  ids: Array<string>;
};

const initialState: TireScansDataReducer = {
  entities: {},
  ids: [],
};

const addMany = (state: TireScansDataReducer, { payload }: FetchTireScansSuccessAction): TireScansDataReducer => ({
  entities: indexByProp('id', payload.content, state.entities),
  ids: uniq([...state.ids, ...payload.content.map(({ id }) => id)]),
});

export default createReducer<TireScansDataReducer>(initialState, {
  [types.FETCH_TIRE_SCAN_SUCCESS]: addMany,
});
